var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useContext, useReducer } from 'react';
import PropTypes from 'prop-types';

var ModalContext = React.createContext();
var types = {};

export var registerModal = function registerModal(name, component) {
  types[name] = component;
};

var reducer = function reducer(state, _ref) {
  var type = _ref.type,
      other = _objectWithoutProperties(_ref, ['type']);

  switch (type) {
    case 'show':
      return other;
    case 'hide':
      return {};
    default:
      return state;
  }
};

export var ModalWrapper = function ModalWrapper(_ref2) {
  var children = _ref2.children;

  var _useReducer = useReducer(reducer, {}),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var ctx = _extends({
    show: function show(modal, options) {
      return dispatch({ type: 'show', modal: modal, options: options });
    },
    hide: function hide() {
      return dispatch({ type: 'hide' });
    }
  }, state);
  return React.createElement(
    ModalContext.Provider,
    { value: ctx },
    children
  );
};
ModalWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};

export var ManualModalWrapper = function ManualModalWrapper(_ref3) {
  var children = _ref3.children,
      ctx = _ref3.ctx;

  return React.createElement(
    ModalContext.Provider,
    { value: ctx },
    children
  );
};
ManualModalWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  ctx: PropTypes.shape({
    show: PropTypes.func.isRequired,
    hide: PropTypes.func.isRequired,
    modal: PropTypes.string
  })
} : {};

export var Modal = function Modal(_ref4) {
  var children = _ref4.children;

  var ctx = useContext(ModalContext);
  if (!ctx.modal) return false;
  var Comp = types[ctx.modal];
  if (!Comp) return false;

  var closeButton = void 0;
  if (children && typeof children === 'function') {
    closeButton = children(ctx.hide);
  } else if (children) {
    closeButton = children;
  } else {
    closeButton = React.createElement('div', { className: 'modal-close', onClick: ctx.hide });
  }

  return React.createElement(
    'div',
    { id: ctx.modal, className: 'modal-background', onClick: ctx.hide },
    React.createElement(
      'div',
      { className: 'modal-foreground', onClick: function onClick(e) {
          return e.stopPropagation();
        } },
      closeButton,
      React.createElement(Comp, ctx.options)
    )
  );
};

Modal.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
} : {};

var ModalLink = function ModalLink(_ref5) {
  var _ref5$tagName = _ref5.tagName,
      tagName = _ref5$tagName === undefined ? 'a' : _ref5$tagName,
      children = _ref5.children,
      modal = _ref5.modal,
      options = _objectWithoutProperties(_ref5, ['tagName', 'children', 'modal']);

  var ctx = useContext(ModalContext);
  var handleClick = function handleClick() {
    return ctx.show(modal, options);
  };
  return React.createElement(tagName, { onClick: handleClick }, children);
};
export { ModalLink };
ModalLink.propTypes = process.env.NODE_ENV !== "production" ? {
  tagName: PropTypes.string,
  children: PropTypes.node,
  modal: PropTypes.string.isRequired
} : {};

var CloseModal = function CloseModal(_ref6) {
  var _ref6$tagName = _ref6.tagName,
      tagName = _ref6$tagName === undefined ? 'a' : _ref6$tagName,
      children = _ref6.children,
      other = _objectWithoutProperties(_ref6, ['tagName', 'children']);

  var ctx = useContext(ModalContext);
  return React.createElement(tagName, { onClick: ctx.hide }, children);
};

export { CloseModal };
export var useModal = function useModal() {
  return useContext(ModalContext);
};